import Nav from './components/Nav.jsx';
import Hero from './components/Hero.jsx';
import About from './components/About.jsx';
import Services from './components/Services.jsx';
import Pullquote from './components/Pullquote.jsx';
import Pricing from './components/Pricing.jsx';
import ContactCTA from './components/ContactCTA.jsx';
import Footer from './components/Footer.jsx';

export default function App() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <About />
        <Services />
        <Pullquote />
        <Pricing />
        <ContactCTA />
      </main>
      <Footer />
    </>
  );
}
